import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { RefObject, useRef } from 'react';

import { ScrollTrigger } from '@/lib/gsap';

interface Props {
	wrapperRef: RefObject<HTMLElement | null>;
	displayedItems: any[];
	cssItemsSelector: string;
	flipStateRef?: RefObject<Flip.FlipState | null>;
	isTransitioningFromEmptyRef?: RefObject<boolean>;
	disabled?: boolean;
}

export const useGridInitialAnimation = ({
	wrapperRef,
	displayedItems,
	cssItemsSelector,
	flipStateRef,
	isTransitioningFromEmptyRef,
	disabled
}: Props) => {
	const hasPlayedRef = useRef(false);

	useGSAP(
		() => {
			if (disabled) {
				hasPlayedRef.current = false;
				return;
			}

			if (displayedItems.length === 0 || !wrapperRef.current) return;

			if (hasPlayedRef.current) return;

			if (flipStateRef?.current || isTransitioningFromEmptyRef?.current) return;

			const gridItems = wrapperRef.current.querySelectorAll(cssItemsSelector);
			if (gridItems.length > 0) {
				gsap.set(gridItems, {
					y: 100,
					opacity: 0
				});

				ScrollTrigger.batch(gridItems, {
					start: 'top 95%',
					onEnter: batch => {
						gsap.to(batch, {
							y: 0,
							opacity: 1,
							duration: 1.5,
							ease: 'power3.out',
							stagger: 0.15,
							overwrite: true
						});
						hasPlayedRef.current = true;
					}
				});
			}
		},
		{ dependencies: [displayedItems, disabled], scope: wrapperRef }
	);
};
